// src/api/functions/bank-accounts/get-bank-accounts.action.ts

import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

/* ──────────────────────────────────────────────
    TYPES
────────────────────────────────────────────── */

// Iranian SRC
export interface IranianSrcBankAccount {
  id: string
  shebaNumber: string
  bankName: string
  cardNumber: string
  ownerFullName: string
  nationalCode: string
  birthDate: string
  verified: number
}

// Iranian Standard
export interface IranianBankAccount {
  id: string
  shebaNumber: string
  bankName: string
  cardNumber: string
  ownerFullName: string
  nationalCode: string
  birthDate: string
  verified: number
}

// International – Revolut
export interface InternationalRevolutBankAccount {
  id: string
  ibanNumber: string
  bicNumber: string
  ownerFullName: string
  revolutTag: string
  bankName: string
}

// International – Paypal
export interface InternationalPaypalBankAccount {
  id: string
  paypalEmail: string
  paypalId: string
  ownerFullName: string
  bankName: string
}

// International (Normal)
export interface InternationalBankAccount {
  id: string
  ibanNumber: string
  bicNumber: string
  ownerFullName: string
  bankName: string
  bankAccountNumber: string | null
  bankAccountSortCode: string | null
  type: string | null
  countryId: number
}
export interface InternationalWiseBankAccount {
  id: string
  ibanNumber: string
  bicNumber: string
  ownerFullName: string
  wiseTag?: string
  bankName: string
}
/* ──────────────────────────────────────────────
    ACTIONS
────────────────────────────────────────────── */

// GET /bank-accounts/:id/iranian-src
export function getIranianSrcBankAccountsAction(accountId: string): Promise<ApiResponse<IranianSrcBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/iranian-src`
  return api.get<ApiResponse<IranianSrcBankAccount[]>>(url)
}

// GET /bank-accounts/:id/iranian
export function getIranianBankAccountsAction(accountId: string): Promise<ApiResponse<IranianBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/iranian`
  return api.get<ApiResponse<IranianBankAccount[]>>(url)
}

// GET /bank-accounts/:id/international-revolut
export function getInternationalRevolutBankAccountsAction(
  accountId: string
): Promise<ApiResponse<InternationalRevolutBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/international-revolut`
  return api.get<ApiResponse<InternationalRevolutBankAccount[]>>(url)
}

// GET /bank-accounts/:id/international-paypal
export function getInternationalPaypalBankAccountsAction(
  accountId: string
): Promise<ApiResponse<InternationalPaypalBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/international-paypal`
  return api.get<ApiResponse<InternationalPaypalBankAccount[]>>(url)
}

// GET /bank-accounts/:id/international
export function getInternationalBankAccountsAction(
  accountId: string
): Promise<ApiResponse<InternationalBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/international`
  return api.get<ApiResponse<InternationalBankAccount[]>>(url)
}

// GET /bank-accounts/:id/international-wise
export function getInternationalWiseBankAccountsAction(
  accountId: string
): Promise<ApiResponse<InternationalWiseBankAccount[]>> {
  const url = `/bank-accounts/${accountId}/international-wise`
  return api.v2.get<ApiResponse<InternationalWiseBankAccount[]>>(url)
}
